import { nativeApplicationVersion } from 'expo-application';
import Constants from 'expo-constants';
import { FALLBACK_APP_VERSION } from 'shared/constants/appVersion';

const appVersion = nativeApplicationVersion as string | null;

export const defaultAppVersion: string =
  Constants.expoConfig?.version !== undefined
    ? Constants.expoConfig.version
    : FALLBACK_APP_VERSION;

export const displayVersion =
  appVersion === '1.0.0' || appVersion === null
    ? defaultAppVersion
    : appVersion;

export const buildNumber =
  (Constants.expoConfig?.extra?.EXPO_APP_BUILD_NUMBER as string) || null;
